import { render, staticRenderFns } from "./qianshu.vue?vue&type=template&id=b31fb084&scoped=true&"
import script from "./qianshu.vue?vue&type=script&lang=js&"
export * from "./qianshu.vue?vue&type=script&lang=js&"
import style0 from "./qianshu.vue?vue&type=style&index=0&id=b31fb084&scoped=true&lang=css&"
import style1 from "./qianshu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31fb084",
  null
  
)

export default component.exports